import React from "react";
import Slider from "react-slick";

function NextArrow({ onClick }) {
  return (
    <button
      type="button"
      className="arrow arrow-right next"
      onClick={onClick}
      aria-label="Next testimonial"
    >
      <i className="fa-solid fa-arrow-right" />
    </button>
  );
}

function PreviousArrow({ onClick }) {
  return (
    <button
      type="button"
      className="arrow arrow-left prev"
      onClick={onClick}
      aria-label="Previous testimonial"
    >
      <i className="fa-solid fa-arrow-left" />
    </button>
  );
}

export default function TestimonialSection({ testimonials }) {
  const testimonialItems = testimonials || [];
  const hasMultipleTestimonials = testimonialItems.length > 1;
  const sliderSettings = {
    slidesToShow: 1,
    arrows: hasMultipleTestimonials,
    autoplay: hasMultipleTestimonials,
    infinite: hasMultipleTestimonials,
    autoplaySpeed: 4000,
    nextArrow: <NextArrow />,
    prevArrow: <PreviousArrow />,
  };

  if (!testimonialItems.length) {
    return null;
  }

  return (
    <section className="testimonial-section">
      <Slider {...sliderSettings} className="slider">
        {testimonialItems.map((testimonial) => (
          <div className="slide-item" key={testimonial.name}>
            <div className="overlay" />
            <div className="content">
              <div className="profile-img">
                <img src={testimonial.image} alt={`${testimonial.name} profile`} />
              </div>
              <p className="quote">{testimonial.quote}</p>
              <p className="name">{testimonial.name}</p>
              <p className="designation">{testimonial.designation}</p>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
}
